import Vue from 'vue';
import Vuex from 'vuex';
import contentEditor from './modules/contentEditor';
import guideEditor from './modules/guideEditor';
import projectEditor from './modules/projectEditor';
import onairDescriptionEditor from './modules/onairDescriptionEditor';
import rewardEditor from './modules/rewardEditor';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.MIX_APP_ENV !== 'production',
  modules: {
    contentEditor,
    guideEditor,
    projectEditor,
    onairDescriptionEditor,
    rewardEditor,
  },
});
